/**
 * 产品卡品牌占位的收尾：首图真正可以画出来之后，把 .card-media--brand 摘掉。
 *
 * 占位是 .media 上的 ::before 伪元素（见 component-card.css），铺在图片下层，
 * 靠"图片盖在上面"来隐藏。但这个前提在好几处都不成立：
 *   - 桌面端 hover 是交叉淡入淡出，两张图同时处于半透明，中点合计只能遮住约 75%，
 *     底层占位从缝里透出来 —— 每次 hover 都会，跟加载状态无关，图片缓存了也一样；
 *   - hover 第二张图是 lazy 的，还没解码时第一张照样淡出到 0，占位整段满强度露出；
 *   - 色卡换图（product-card.js）会把主图 opacity 归零并留出 200ms 空档。
 *
 * 所以不再依赖层叠顺序：图片一旦确认能画出来，就在 DOM 层面把 class 去掉。
 * "图片是否已经可以绘制"这个状态 CSS 表达不了，这是本文件存在的唯一理由。
 *
 * 覆盖范围（别再写成"覆盖任何路径"，下面第 2 条是有条件的）：
 *   1. 页面里加载的图 —— 捕获阶段的 load 监听自动兜住，含 AJAX 筛选 / load more 新插入的卡；
 *   2. 在文档之外加载完、之后才插进 DOM 的图（色卡换图就是这种）—— load 事件路径里
 *      没有 document，监听看不到，插入后也不补发 load。这类代码必须自己调一次
 *      window.cardPlaceholder.settle(img)。product-card.js 已经这么做了。
 */
(function () {
  var BRAND = 'card-media--brand';
  var STATIC = 'card-media--brand-static';

  function firstImage(media) {
    return media ? media.querySelector('img') : null;
  }

  function paintable(img) {
    // 无图产品（压根没有 img）或加载失败（naturalWidth 为 0）：占位留着，本来就该一直显示。
    // 破图比品牌兜底难看，宁可不摘。
    return !!(img && img.complete && img.naturalWidth);
  }

  function settle(media) {
    if (!media || !media.classList || !media.classList.contains(BRAND)) return;

    var img = firstImage(media);
    if (!paintable(img)) return;

    function drop() {
      if (!media.classList.contains(BRAND)) return;
      var current = firstImage(media);
      if (current !== img) {
        // decode 期间首图被换掉了（色卡换图就会这么干）。不能拿旧图的解码结果
        // 替新图背书 —— 新图可能刚加载完还没解码，摘早了就是一帧空白。重新判一遍。
        settle(media);
        return;
      }
      if (!paintable(current)) return;
      media.classList.remove(BRAND, STATIC);
    }

    // complete 只说明资源可解码，不等于这一帧画得出来 —— 大图在 Chrome 里是异步解码的。
    // 直接摘会把"闪一下品牌"换成"闪一帧空白"，所以等 decode() 完成、下一帧再摘。
    if (typeof img.decode !== 'function') {
      drop();
      return;
    }
    img.decode().then(function () {
      requestAnimationFrame(drop);
    }, function () {
      /* 解码失败：占位留着 */
    });
  }

  function settleFrom(node) {
    if (!node || !node.closest) return;
    settle(node.closest('.' + BRAND));
  }

  function sweep(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.' + BRAND).forEach(settle);
  }

  // 给"文档外加载完才插进来"的代码用（见文件头第 2 条）
  window.cardPlaceholder = { settle: settleFrom, sweep: sweep };

  // load 事件不冒泡，挂在 document 的捕获阶段兜底：
  // 覆盖页面里加载的图，含 AJAX 筛选 / load more 之后新插入的卡，不必挂 MutationObserver。
  document.addEventListener(
    'load',
    function (event) {
      var target = event.target;
      if (!target || target.tagName !== 'IMG') return;
      settleFrom(target);
    },
    true
  );

  // 先挂监听再扫一遍：执行前就已经加载完的图，load 事件早就派发过了，只能靠 complete
  // 补判。顺序反了会留下空档。
  sweep();

  // 脚本是 async 的（theme.liquid 里排在所有脚本之前，不等那 261KB 的 defer 队列），
  // 所以很可能在产品卡进入 DOM 之前就跑到这里，上面那次 sweep 什么都扫不到。
  // DOM 解析完再扫一次；window load 兜最后一次。中间新加载的图由捕获监听负责。
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { sweep(); });
  }

  window.addEventListener('load', function () { sweep(); });
  document.addEventListener('shopify:section:load', function (event) { sweep(event.target); });
})();
